export const loadUrl = (payload) => {
  return {
    type: "LOAD_URL",
    payload,
  };
};

export const loadSpin = (payload) => {
  // Action returned by this creator is to load a spin based on an
  // object from setSpinData message from container
  // Schema defined here https://docs.google.com/document/d/1ttD8Sdra4W-UhhLP15C6agjCmXDcS6h-2I18wUAbZ0A/edit#heading=h.dhse4avpgkei
  return {
    type: "LOAD_SPIN",
    payload,
  };
};

export const setHoverActionDebounced = (payload) => {
  return {
    type: "SET_HOVER_ACTION_DEBOUNCED",
    payload,
  };
};

export const setClickActionBoxContentDebounced = (payload) => {
  return {
    type: "SET_CLICK_ACTION_DEBOUNCED",
    payload,
  };
};

export const copyHotspotsFromUrl = (payload) => {
  return {
    type: "COPY_HOTSPOTS_FROM_URL",
    payload,
  };
};

export const addHotspotFromUI = (payload) => {
  return {
    type: "ADD_HOTSPOT_FROM_UI",
    payload,
  };
};

export const updateSpinInfoHotspots = (payload) => {
  return {
    type: "UPDATE_SPIN_INFO_HOTSPOTS",
    payload,
  };
};

export const demonstrateHotspotPath = (payload) => {
  return {
    type: "DEMONSTRATE_HOTSPOT_PATH",
    payload,
  };
};

export const requestImage = (payload) => {
  return {
    type: "REQUEST_IMAGE",
    payload,
  };
};
